const BaseHrmUrl = 'https://kalsoft.kadesea.co.ke/hrm';

export   {BaseHrmUrl} 

